import ResponsiveImage from 'components/core/ResponsiveImage'
import Markdown from 'markdown-to-jsx'
import { BlogPostModel } from 'models/core/BlogPostModel'
import Link from 'next/link'
import React, { Fragment, FunctionComponent } from 'react'
import dayjs from 'dayjs'

type Props = {
  post: BlogPostModel['data']
}

const BlogPostPreviewCard: FunctionComponent<Props> = (props) => {
  const category = props.post.attributes.category.data.attributes
  const authors = props.post.attributes.authors
  return (
    <Fragment>
      <div className="blog-item group mb-[60px]">
        <Link href={`/blog/${props.post.attributes.slug}`}>
          <a>
            <div className="text-center mb-[30px] relative">
              <ResponsiveImage extraClassNames="w-full" data={props.post.attributes.featureImage} />
              <div className="overlay bg-white/90 transition-all duration-300 absolute top-0 right-0 w-full h-full opacity-0 group-hover:opacity-100 text-black flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd"></path>
                </svg>
              </div>
            </div>
          </a>
        </Link>
        <Link href={`/blog/${props.post.attributes.slug}`}>
          <a>
            <h3 className="md:text-[26px] text-[18px] font-lato font-bold leading-tight text-[#333]">{props.post.attributes.title}</h3>
          </a>
        </Link>
        <div className="post-meta text-sm mb-2 font-bold text-left">
          {authors && !!authors.data.length &&
            <>
              By{' '}
              <span className="author inline-block border-r border-solid border-black mr-1">
                {authors.data.map((author, index) => (
                  <a key={index} className="text-[#666] font-normal pr-1" href="javascript:void(0);">
                    {author.attributes.firstName} {author.attributes.lastName}
                    {(index == authors.data.length - 1 ) ? '' : ','}
                  </a>
                ))}
              </span>
              </>
            }
          <span className="published border-r border-solid border-black pr-1">{dayjs(props.post.attributes.publishedAt).format('MMM DD YYYY')}</span>
          <ul className="inline-block">
            <li className="inline-block">
              <a className="text-[rgb(240,103,37)] font-normal ml-1" href={`/blog-categories/${category.slug}`}>
                {category.title}
              </a>
            </li>
          </ul>
        </div>
        <div className="post-content text-base leading-[26px] text-[#666]">
          <div className="line-clamp-2">{props.post.attributes.shortDescription}</div>
          <Link href={`/blog/${props.post.attributes.slug}`}>
            <a className="more-link text-[#f06725] text-base capitalize bg-icon-right bg-no-repeat bg-right transition-all pr-10 hover:pr-11">read more</a>
          </Link>
        </div>
      </div>
    </Fragment>
  )
}

export default BlogPostPreviewCard
